export default __webpack_public_path__ + "static/media/i_think_its_finished_priska_turbo_time.7eef5538.mp3";